import { render, staticRenderFns } from "./DispatcherServiceObjectsTabCreateRequests.vue?vue&type=template&id=72b19d87&"
import script from "./DispatcherServiceObjectsTabCreateRequests.vue?vue&type=script&lang=js&"
export * from "./DispatcherServiceObjectsTabCreateRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QIcon,QItem,QSelect,QTooltip,QExpansionItem,QSeparator,QItemSection,QCheckbox,QInnerLoading,QSpinnerGears,QCardActions,QSpace,QBtn} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QIcon,QItem,QSelect,QTooltip,QExpansionItem,QSeparator,QItemSection,QCheckbox,QInnerLoading,QSpinnerGears,QCardActions,QSpace,QBtn}, component.options.components || {})
